import React, { Fragment } from 'react';
import { Button, UncontrolledTooltip } from 'reactstrap';
export default function CustomViewButton(props){  
    const {keyvalue} = props;  
    return(
        <Fragment>
            <Button className='action-btn' color='success' id={`tooltip_view_key_${keyvalue}`} {...props}>
                <span className='fas fa-eye'></span>
            </Button>
            <UncontrolledTooltip placement="top" target={`tooltip_view_key_${keyvalue}`}>
                View
            </UncontrolledTooltip>
        </Fragment>
    );
}